import isSxSDisplayed from './isSxSDisplayed';
import { getNewStore } from '../store/Store';
import { isFeatureEnabled } from 'owa-feature-flags';
import DisplayMode from '../store/schema/DisplayMode';

/**
 * This function returns true if any SxS is being displayed in main window
 * For now it handles both legacy and refactored SxS
 */
export default function isAnySxSDisplayedInMainWindow(): boolean {
    if (isFeatureEnabled('doc-SxS-multipleViews')) {
        for (const sxsId of getNewStore().sxsStoreMapping.keys()) {
            const storeData = getNewStore().sxsStoreMapping.get(sxsId);
            if (storeData.shouldShow && storeData.displayMode == DisplayMode.MainWindow) {
                return true;
            }
        }
        return false;
    } else {
        return isSxSDisplayed('sxsIdPlaceHolder');
    }
}
